import { createContext, ReactNode, useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";

export const PreviousRouteContext = createContext<string | null>("");

const PreviousRouteProvider = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const [previousRoute, setPreviousRoute] = useState<string | null>(null);
  const previousPathRef = useRef(router.asPath);

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      setPreviousRoute(previousPathRef.current);
      previousPathRef.current = url;
    };

    router.events.on("routeChangeStart", handleRouteChange);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router]);

  return (
    <PreviousRouteContext.Provider value={previousRoute}>
      {children}
    </PreviousRouteContext.Provider>
  );
};

export default PreviousRouteProvider;
